<template>
  <nav>
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{disabled : currentPage === 1}">
        <a class="page-link" :aria-label="$t('paginacion.anterior')" @click="previous()">
          <span aria-hidden="true">&laquo;</span>
          <span class="sr-only">{{ $t('paginacion.anterior') }}</span>
        </a>
      </li>
      <li class="page-item" :class="{active: pageNumber === currentPage}" v-for="pageNumber in totalPages"
          v-if="pageNumber >= startPage && pageNumber <= endPage">
        <a class="page-link" @click="goToPage(pageNumber)">{{ pageNumber }}</a>
      </li>
      <li class="page-item" :class="{disabled : currentPage === totalPages}">
        <a class="page-link" :aria-label="$t('paginacion.siguiente')" @click="next()">
          <span aria-hidden="true">&raquo;</span>
          <span class="sr-only">{{ $t('paginacion.siguiente') }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>

    export default {
        name: 'Paginator',
        props: {
            totalPages: {
                type: Number
            },
            currentPage: {
                type: Number
            },

        },
        data() {
            return {
                startPage: 0,
                endPage: 0
            }
        },
        watch: {
            currentPage: function (newQuestion, oldQuestion) {
                this.calcStarterPages(newQuestion);
            }
        },
        mounted() {
            this.calcStarterPages(this.currentPage);
        },
        methods: {
            goToPage(pageNumber) {
                this.$emit('update:currentPage', pageNumber);
            },
            calcStarterPages(pageNumber) {
                const PAGE_PER_SIDE = 2;

                let tempStartPage = (pageNumber < (PAGE_PER_SIDE + 1)) ? 1 : pageNumber - PAGE_PER_SIDE;
                let tempEndPage = PAGE_PER_SIDE * 2 + tempStartPage;
                tempEndPage = (this.totalPages < tempEndPage) ? this.totalPages : tempEndPage;
                let diff = tempStartPage - tempEndPage + PAGE_PER_SIDE * 2;
                tempStartPage -= (tempStartPage - diff > 0) ? diff : 0;

                this.startPage = tempStartPage;
                this.endPage = tempEndPage;
            },
            next() {
                if (this.currentPage < this.totalPages)
                    this.$emit('update:currentPage', this.currentPage + 1)
            },
            previous() {
                if (this.currentPage > 1)
                    this.$emit('update:currentPage', this.currentPage - 1)
            }
        }
    }
</script>